import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "velvet_token";

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

api.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const skip = /auth\/(login|register|refresh|logout)/.test(cfg.url || "");
    if (err.response?.status === 401 && !cfg._retry && !skip) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        const { data } = await refreshing;
        setToken(data.access_token);
        return api(cfg);
      } catch (e) {
        setToken(null);
        if (cfg.headers) delete cfg.headers.Authorization;
        if (!/auth\/me/.test(cfg.url || "")) return api(cfg);
      } finally {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export const mediaSrc = (u) => (!u ? null : u.startsWith("http") ? u : `${BACKEND_URL}${u}`);

export function formatErr(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const plural = (n, word) => `${n} ${word}${n === 1 ? "" : "s"}`;

export const fmtCount = (n) => {
  const trim = (x) => x.toFixed(1).replace(/\.0$/, "");
  if (n >= 1e6) return `${trim(n / 1e6)}M`;
  if (n >= 1e3) return `${trim(n / 1e3)}K`;
  return `${n || 0}`;
};

export const timeAgo = (iso) => {
  const s = Math.max(1, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  const units = [["y", 31536000], ["mo", 2592000], ["d", 86400], ["h", 3600], ["m", 60]];
  for (const [u, v] of units) if (s >= v) return `${Math.floor(s / v)}${u} ago`;
  return "just now";
};
